







































import {Emit} from "vue-property-decorator";
import {InOut} from 'vue-inout-prop-decorator';
import {Component, Vue} from '@/shared/component';

import {LongueursAchat} from '@/models';

import CrudLongueursAchatEdit from '@/components/Crud/LongueursAchat/Edit.vue';

@Component({
	components: {
		CrudLongueursAchatEdit,
	}
})
export default class CrudLongueursAchatEditDialog extends Vue {
	@InOut({ type: LongueursAchat  , isVModel: true }) private value!: LongueursAchat;

	@Emit()
	private onSubmit(longueursAchat: LongueursAchat) {
		this.onClose();
	}

	@Emit()
	private onClose() {
		this.value = null;
	}
}
